var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-group"},[(_vm.header)?_c('h3',[_vm._v(_vm._s(_vm.header))]):_vm._e(),_c('div',{staticClass:"radio-group__inputs"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }